<button
  mat-flat-button
  color="primary"
  ngForm="formGroup"
  [disabled]="!!formGroup && formGroup.invalid"
  (click)="clicked.emit($event)"
>
  <ng-content></ng-content>
</button>
